// Icon: material-symbols:masked-transitions
// Slug: Sets `view-transition-name` styles.
// Description: Sets the `view-transition-name` style attribute explicitly.

import { attribute } from '@engine'
import { effect } from '@engine/signals'
import { supportsViewTransitions } from '@utils/view-transitions'

attribute({
  name: 'view-transition',
  requirement: {
    key: 'denied',
    value: 'must',
  },
  returnsValue: true,
  apply({ el, rx }) {
    if (!supportsViewTransitions) {
      console.warn('Browser does not support view transitions')
      return
    }
    return effect(() => {
      const name = rx() as string
      if (name) {
        el.style.viewTransitionName = name
      }
    })
  },
})
